import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "3d08293e-510d-45ac-8cb8-309a621e6576"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHero3d08293e510d45ac8cb8309a621e6576(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHero3d08293e510d45ac8cb8309a621e6576 hero`}>
      <h1 className="title">
        {props["title"] || Title66f88ea9140f4c498e2cBab9841bae17}
      </h1>
    </div>
  );
}

// id: "bd4301e5-169f-4827-8762-57145cee2bfb"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "d9f56fcc-b2b2-4d63-9734-30eed59f0138"
export function GroupflowBd4301e5169f4827876257145cee2bfb(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="GroupflowBd4301e5169f4827876257145cee2bfb" parentTag={buildClassName("GroupflowBd4301e5169f4827876257145cee2bfb", parentTag)} {...props} />
  );
}

// id: "ffbddc3a-eba5-414c-810b-d8213b83bac6"
// title: ""
// type: :html
// key: "hero-wrapper"
// parent_id: "9d78921b-a7d8-4842-bc68-ee210b654049"
export function HeroWrapperFfbddc3aEba5414c810bD8213b83bac6(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeroWrapperFfbddc3aEba5414c810bD8213b83bac6`}>
      {props["hero"] || <Hero className="Hero5428d374213a423f9aaa1b0512cfc003" parentTag={buildClassName("Hero5428d374213a423f9aaa1b0512cfc003", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "be9bce04-a6c8-4f2a-b2ed-270f93454f4f"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "e1b244cd-ea91-49af-b8c2-8e116d501fce"
export const PostSlugBe9bce04A6c84f2aB2ed270f93454f4f = "about-us-cards";

// id: "2883bd14-5fa0-4684-9e23-9ec4d007d92e"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPage2883bd145fa046849e239ec4d007d92e(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPage2883bd145fa046849e239ec4d007d92e`}>
      {props["header"] || <SecondaryMarketingHeaderCe96a641072a46efB2f59e447638ac58 parentTag="HeaderDf2aca67A9b84a82B494A93e21d7fdc4" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterD9f56fccB2b24d63973430eed59f0138 parentTag="Footer76d3015a37674ecdB6453d1b71641376" {...props} />}
    </div>
  );
}

// id: "9b2ace85-7e86-4120-a98d-bfcc4c323525"
// title: ""
// type: :html
// key: "main"
// parent_id: "9acd1450-9690-4b2f-ad7a-7c2710eef3f7"
export function Main9b2ace857e864120A98dBfcc4c323525(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} Main9b2ace857e864120A98dBfcc4c323525`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="CardsE1b244cdEa9149afB8c28e116d501fce" parentTag={buildClassName("CardsE1b244cdEa9149afB8c28e116d501fce", parentTag)} postSlug="about-us-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "c2b3b3da-6f8d-42ac-80ad-9e74dcca6aaf"
// title: ""
// type: :text
// key: "title"
// parent_id: "509c050c-0de8-4f87-9d24-409161a6419b"
export const TitleC2b3b3da6f8d42ac80ad9e74dcca6aaf = "Join Us";

// id: "85f8f53a-b319-4bc1-b7c3-e872bb344b72"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "c6e4cd41-6b18-4ee5-b21e-ff1ca4f626ca"
export const ContentSlug85f8f53aB3194bc1B7c3E872bb344b72 = "header-logo";

// id: "ce96a641-072a-46ef-b2f5-9e447638ac58"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeaderCe96a641072a46efB2f59e447638ac58(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeaderCe96a641072a46efB2f59e447638ac58 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopE5a46c72B5e048cc9024D8b314e5dc90 parentTag="HeaderTopC554adefF85d4c7286617e66ea098ebf" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHero3d08293e510d45ac8cb8309a621e6576 parentTag="HeroA174b1aa9b6e4e198487Ddaaf1492911" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "6f962ace-03a2-4a45-a856-bc8eb4e878d2"
// title: ""
// type: :reference
// key: "header"
// parent_id: "9acd1450-9690-4b2f-ad7a-7c2710eef3f7"
export function Header6f962ace03a24a45A856Bc8eb4e878d2(props: any) {
  return (
    <SecondaryMarketingHeaderCe96a641072a46efB2f59e447638ac58 parentTag="Header6f962ace03a24a45A856Bc8eb4e878d2" title="About Us" {...props} />
  );
}

// id: "912ab4cc-b4f4-4138-aa53-f940756e8aa3"
// title: ""
// type: :text
// key: "title"
// parent_id: "5b29bdca-0156-419c-8802-662620207383"
export const Title912ab4ccB4f44138Aa53F940756e8aa3 = "Secondary Page";

// id: "5428d374-213a-423f-9aaa-1b0512cfc003"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "ffbddc3a-eba5-414c-810b-d8213b83bac6"
export function Hero5428d374213a423f9aaa1b0512cfc003(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="Hero5428d374213a423f9aaa1b0512cfc003" parentTag={buildClassName("Hero5428d374213a423f9aaa1b0512cfc003", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "7c8f73c5-03af-4cbf-b467-a544f2b7af0e"
// title: "Member Application Pages"
// type: :reference
// key: "application-pages"
// parent_id: nil
export function ApplicationPages7c8f73c503af4cbfB467A544f2b7af0e(props: any) {
  return (
    <SecondaryPageD01dafa4435540249a9cC7e1b80d52af parentTag="ApplicationPages7c8f73c503af4cbfB467A544f2b7af0e" header={<SecondaryMarketingHeaderCe96a641072a46efB2f59e447638ac58 parentTag="HeaderA5eb75f925a442619d4d66edf35242c6" title="Join Us" />} {...props} />
  );
}

// id: "06d8f714-57f3-4d9a-b194-ab101caf98e4"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "e5a46c72-b5e0-48cc-9024-d8b314e5dc90"
export function Logo06d8f71457f34d9aB194Ab101caf98e4(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo06d8f71457f34d9aB194Ab101caf98e4" parentTag={buildClassName("Logo06d8f71457f34d9aB194Ab101caf98e4", parentTag)} logoType="DEFAULT" {...props} />
  );
}

// id: "9fb6c2d9-1dd0-4c26-a907-876089f80944"
// title: ""
// type: :text
// key: "title"
// parent_id: "a174b1aa-9b6e-4e19-8487-ddaaf1492911"
export const Title9fb6c2d91dd04c26A907876089f80944 = "Secondary Marketing Title 2";

// id: "c5718482-ccf5-4999-92e3-c6e6d5973f06"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "53c9162b-eaa4-419a-928f-b326110cabf7"
export const ButtonClassC5718482Ccf5499992e3C6e6d5973f06 = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "d9f56fcc-b2b2-4d63-9734-30eed59f0138"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooterD9f56fccB2b24d63973430eed59f0138(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooterD9f56fccB2b24d63973430eed59f0138 footer`}>
      {props["links"] || <Navigation className="LinksCf5d3d7cE64641818a06B3a6a2715f18" parentTag={buildClassName("LinksCf5d3d7cE64641818a06B3a6a2715f18", parentTag)} navMenuSlug="footer-nav" themeArea="marketing" purpose="footer" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="LogoFd86a3e387f14dd6Bc92D001cfd91952" parentTag={buildClassName("LogoFd86a3e387f14dd6Bc92D001cfd91952", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright30bfe7e5Dd784e8e916d6b3199deebc9" parentTag={buildClassName("Copyright30bfe7e5Dd784e8e916d6b3199deebc9", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="GroupflowBd4301e5169f4827876257145cee2bfb" parentTag={buildClassName("GroupflowBd4301e5169f4827876257145cee2bfb", parentTag)} {...props} />}
    </footer>
  );
}

// id: "a5eb75f9-25a4-4261-9d4d-66edf35242c6"
// title: ""
// type: :reference
// key: "header"
// parent_id: "7c8f73c5-03af-4cbf-b467-a544f2b7af0e"
export function HeaderA5eb75f925a442619d4d66edf35242c6(props: any) {
  return (
    <SecondaryMarketingHeaderCe96a641072a46efB2f59e447638ac58 parentTag="HeaderA5eb75f925a442619d4d66edf35242c6" title="Join Us" {...props} />
  );
}

// id: "e1b244cd-ea91-49af-b8c2-8e116d501fce"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "9b2ace85-7e86-4120-a98d-bfcc4c323525"
export function CardsE1b244cdEa9149afB8c28e116d501fce(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="CardsE1b244cdEa9149afB8c28e116d501fce" parentTag={buildClassName("CardsE1b244cdEa9149afB8c28e116d501fce", parentTag)} postSlug="about-us-cards" {...props} />
  );
}

// id: "61c6b4a1-5188-458a-95cf-ab280813007d"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "5428d374-213a-423f-9aaa-1b0512cfc003"
export const PostSlug61c6b4a15188458a95cfAb280813007d = "home-hero";

// id: "e5a46c72-b5e0-48cc-9024-d8b314e5dc90"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopE5a46c72B5e048cc9024D8b314e5dc90(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopE5a46c72B5e048cc9024D8b314e5dc90 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo2bc60502021b45d98ff8293f70cdafb5" parentTag={buildClassName("LinkedLogo2bc60502021b45d98ff8293f70cdafb5", parentTag)} className="linked-logo" label={<Logo className="LabelC6e4cd416b184ee5B21eFf1ca4f626ca" parentTag={buildClassName("LabelC6e4cd416b184ee5B21eFf1ca4f626ca", parentTag)} contentSlug="header-logo" logoType="DEFAULT" {...props} />} url="/" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation97d41720Bbee4152A865070ea9697bc8" parentTag={buildClassName("Navigation97d41720Bbee4152A865070ea9697bc8", parentTag)} navMenuSlug="marketing-primary-nav" className="navigation" {...props} />}
    </div>
  );
}

// id: "e526be19-fde4-4d2f-88f8-4fd0c51db5f4"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "d01dafa4-4355-4024-9a9c-c7e1b80d52af"
export function FooterE526be19Fde44d2f88f84fd0c51db5f4(props: any) {
  return (
    <DefaultFooterD9f56fccB2b24d63973430eed59f0138 parentTag="FooterE526be19Fde44d2f88f84fd0c51db5f4" {...props} />
  );
}

// id: "717947d5-6eef-4091-a84d-8b71f6f625f3"
// title: ""
// type: :text
// key: "title"
// parent_id: "a5eb75f9-25a4-4261-9d4d-66edf35242c6"
export const Title717947d56eef4091A84d8b71f6f625f3 = "Join Us";

// id: "6f1d5dbf-0941-45f1-89b4-b6fb76f47707"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage6f1d5dbf094145f189b4B6fb76f47707(props: any) {
  const Header = AppStore.presets["Header"];
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage6f1d5dbf094145f189b4B6fb76f47707 gf-page-layout`}>
      {props["header-wrapper"] || <HeaderWrapper9d78921bA7d84842Bc68Ee210b654049 />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack52de4c7235b34d4a81d85d8ce9ded56b" parentTag={buildClassName("WelcomeBack52de4c7235b34d4a81d85d8ce9ded56b", parentTag)} {...props} />}
      {props["main"] || <MainF258fb1b23de4204B2f69f878e441d9c />}
      {props["quote"] || <PageQuote className="Quote1bc6518f87284904905fA49b980efb0b" parentTag={buildClassName("Quote1bc6518f87284904905fA49b980efb0b", parentTag)} contentSlug="home-page-quote" {...props} />}
      {props["footer"] || <DefaultFooterD9f56fccB2b24d63973430eed59f0138 parentTag="Footer8170d60102e34d8e85b1791b87289cf6" {...props} />}
    </div>
  );
}

// id: "f258fb1b-23de-4204-b2f6-9f878e441d9c"
// title: "Home Main"
// type: :html
// key: "main"
// parent_id: "6f1d5dbf-0941-45f1-89b4-b6fb76f47707"
export function MainF258fb1b23de4204B2f69f878e441d9c(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} MainF258fb1b23de4204B2f69f878e441d9c`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards53c9162bEaa4419a928fB326110cabf7" parentTag={buildClassName("Cards53c9162bEaa4419a928fB326110cabf7", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "e987c57e-3c1c-4786-9c8a-abb1627f0783"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "1bc6518f-8728-4904-905f-a49b980efb0b"
export const ContentSlugE987c57e3c1c47869c8aAbb1627f0783 = "home-page-quote";

// id: "d01dafa4-4355-4024-9a9c-c7e1b80d52af"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPageD01dafa4435540249a9cC7e1b80d52af(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPageD01dafa4435540249a9cC7e1b80d52af`}>
      {props["header"] || <SecondaryMarketingHeaderCe96a641072a46efB2f59e447638ac58 parentTag="Header5b29bdca0156419c8802662620207383" title="Secondary Page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterD9f56fccB2b24d63973430eed59f0138 parentTag="FooterE526be19Fde44d2f88f84fd0c51db5f4" {...props} />}
    </div>
  );
}

// id: "a9b7743b-7aeb-45c0-bc51-86a97e1e2674"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "9acd1450-9690-4b2f-ad7a-7c2710eef3f7"
export function FooterA9b7743b7aeb45c0Bc5186a97e1e2674(props: any) {
  return (
    <DefaultFooterD9f56fccB2b24d63973430eed59f0138 parentTag="FooterA9b7743b7aeb45c0Bc5186a97e1e2674" {...props} />
  );
}

// id: "9e81614f-91fd-4c81-a91b-d48b3bbc06ab"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "cf5d3d7c-e646-4181-8a06-b3a6a2715f18"
export const NavMenuSlug9e81614f91fd4c81A91bD48b3bbc06ab = "footer-nav";

// id: "7bea4188-4bb3-4087-a9df-5fa26d578ba9"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPage7bea41884bb34087A9df5fa26d578ba9(props: any) {
  return (
    <SecondaryPageD01dafa4435540249a9cC7e1b80d52af parentTag="JoinUsPage7bea41884bb34087A9df5fa26d578ba9" header={<SecondaryMarketingHeaderCe96a641072a46efB2f59e447638ac58 parentTag="Header509c050c0de84f879d24409161a6419b" title="Join Us" />} {...props} />
  );
}

// id: "2bc60502-021b-45d9-8ff8-293f70cdafb5"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "e5a46c72-b5e0-48cc-9024-d8b314e5dc90"
export function LinkedLogo2bc60502021b45d98ff8293f70cdafb5(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo2bc60502021b45d98ff8293f70cdafb5" parentTag={buildClassName("LinkedLogo2bc60502021b45d98ff8293f70cdafb5", parentTag)} className="linked-logo" label={<Logo className="LabelC6e4cd416b184ee5B21eFf1ca4f626ca" parentTag={buildClassName("LabelC6e4cd416b184ee5B21eFf1ca4f626ca", parentTag)} contentSlug="header-logo" logoType="DEFAULT" {...props} />} url="/" {...props} />
  );
}

// id: "226c45fc-be1a-413b-9f53-d6995096d35d"
// title: ""
// type: :text
// key: "class"
// parent_id: "2bc60502-021b-45d9-8ff8-293f70cdafb5"
export const Class226c45fcBe1a413b9f53D6995096d35d = "linked-logo";

// id: "9acd1450-9690-4b2f-ad7a-7c2710eef3f7"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPage9acd145096904b2fAd7a7c2710eef3f7(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPage9acd145096904b2fAd7a7c2710eef3f7 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeaderCe96a641072a46efB2f59e447638ac58 parentTag="Header6f962ace03a24a45A856Bc8eb4e878d2" title="About Us" {...props} />}
      {props["main"] || <Main9b2ace857e864120A98dBfcc4c323525 />}
      {props["footer"] || <DefaultFooterD9f56fccB2b24d63973430eed59f0138 parentTag="FooterA9b7743b7aeb45c0Bc5186a97e1e2674" {...props} />}
    </div>
  );
}

// id: "cf5d3d7c-e646-4181-8a06-b3a6a2715f18"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "d9f56fcc-b2b2-4d63-9734-30eed59f0138"
export function LinksCf5d3d7cE64641818a06B3a6a2715f18(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksCf5d3d7cE64641818a06B3a6a2715f18" parentTag={buildClassName("LinksCf5d3d7cE64641818a06B3a6a2715f18", parentTag)} navMenuSlug="footer-nav" themeArea="marketing" purpose="footer" {...props} />
  );
}

// id: "53c9162b-eaa4-419a-928f-b326110cabf7"
// title: "Home Cards"
// type: :gf_preset
// key: "cards"
// parent_id: "f258fb1b-23de-4204-b2f6-9f878e441d9c"
export function Cards53c9162bEaa4419a928fB326110cabf7(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards53c9162bEaa4419a928fB326110cabf7" parentTag={buildClassName("Cards53c9162bEaa4419a928fB326110cabf7", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />
  );
}

// id: "66f88ea9-140f-4c49-8e2c-bab9841bae17"
// title: ""
// type: :text
// key: "title"
// parent_id: "3d08293e-510d-45ac-8cb8-309a621e6576"
export const Title66f88ea9140f4c498e2cBab9841bae17 = "Default Title";

// id: "c6e4cd41-6b18-4ee5-b21e-ff1ca4f626ca"
// title: "Home Page Logo"
// type: :gf_preset
// key: "label"
// parent_id: "2bc60502-021b-45d9-8ff8-293f70cdafb5"
export function LabelC6e4cd416b184ee5B21eFf1ca4f626ca(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LabelC6e4cd416b184ee5B21eFf1ca4f626ca" parentTag={buildClassName("LabelC6e4cd416b184ee5B21eFf1ca4f626ca", parentTag)} contentSlug="header-logo" logoType="DEFAULT" {...props} />
  );
}

// id: "5b29bdca-0156-419c-8802-662620207383"
// title: ""
// type: :reference
// key: "header"
// parent_id: "d01dafa4-4355-4024-9a9c-c7e1b80d52af"
export function Header5b29bdca0156419c8802662620207383(props: any) {
  return (
    <SecondaryMarketingHeaderCe96a641072a46efB2f59e447638ac58 parentTag="Header5b29bdca0156419c8802662620207383" title="Secondary Page" {...props} />
  );
}

// id: "df2aca67-a9b8-4a82-b494-a93e21d7fdc4"
// title: ""
// type: :reference
// key: "header"
// parent_id: "2883bd14-5fa0-4684-9e23-9ec4d007d92e"
export function HeaderDf2aca67A9b84a82B494A93e21d7fdc4(props: any) {
  return (
    <SecondaryMarketingHeaderCe96a641072a46efB2f59e447638ac58 parentTag="HeaderDf2aca67A9b84a82B494A93e21d7fdc4" title="Public Events" {...props} />
  );
}

// id: "0577bcf2-79cc-4e12-970b-ce2bef024c5e"
// title: ""
// type: :text
// key: "title"
// parent_id: "df2aca67-a9b8-4a82-b494-a93e21d7fdc4"
export const Title0577bcf279cc4e12970bCe2bef024c5e = "Public Events";

// id: "fd86a3e3-87f1-4dd6-bc92-d001cfd91952"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "d9f56fcc-b2b2-4d63-9734-30eed59f0138"
export function LogoFd86a3e387f14dd6Bc92D001cfd91952(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LogoFd86a3e387f14dd6Bc92D001cfd91952" parentTag={buildClassName("LogoFd86a3e387f14dd6Bc92D001cfd91952", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />
  );
}

// id: "8170d601-02e3-4d8e-85b1-791b87289cf6"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "6f1d5dbf-0941-45f1-89b4-b6fb76f47707"
export function Footer8170d60102e34d8e85b1791b87289cf6(props: any) {
  return (
    <DefaultFooterD9f56fccB2b24d63973430eed59f0138 parentTag="Footer8170d60102e34d8e85b1791b87289cf6" {...props} />
  );
}

// id: "0130ff71-23b1-48a1-838d-457ad9cc1280"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "97d41720-bbee-4152-a865-070ea9697bc8"
export const NavMenuSlug0130ff7123b148a1838d457ad9cc1280 = "marketing-primary-nav";

// id: "509c050c-0de8-4f87-9d24-409161a6419b"
// title: ""
// type: :reference
// key: "header"
// parent_id: "7bea4188-4bb3-4087-a9df-5fa26d578ba9"
export function Header509c050c0de84f879d24409161a6419b(props: any) {
  return (
    <SecondaryMarketingHeaderCe96a641072a46efB2f59e447638ac58 parentTag="Header509c050c0de84f879d24409161a6419b" title="Join Us" {...props} />
  );
}

// id: "c554adef-f85d-4c72-8661-7e66ea098ebf"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "ce96a641-072a-46ef-b2f5-9e447638ac58"
export function HeaderTopC554adefF85d4c7286617e66ea098ebf(props: any) {
  return (
    <DefaultHeaderTopE5a46c72B5e048cc9024D8b314e5dc90 parentTag="HeaderTopC554adefF85d4c7286617e66ea098ebf" {...props} />
  );
}

// id: "a509dd76-a0a9-4cf6-9304-f80b146eaf74"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "fd86a3e3-87f1-4dd6-bc92-d001cfd91952"
export const ContentSlugA509dd76A0a94cf69304F80b146eaf74 = "footer-logo";

// id: "1bc6518f-8728-4904-905f-a49b980efb0b"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "6f1d5dbf-0941-45f1-89b4-b6fb76f47707"
export function Quote1bc6518f87284904905fA49b980efb0b(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="Quote1bc6518f87284904905fA49b980efb0b" parentTag={buildClassName("Quote1bc6518f87284904905fA49b980efb0b", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "97d41720-bbee-4152-a865-070ea9697bc8"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "e5a46c72-b5e0-48cc-9024-d8b314e5dc90"
export function Navigation97d41720Bbee4152A865070ea9697bc8(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation97d41720Bbee4152A865070ea9697bc8" parentTag={buildClassName("Navigation97d41720Bbee4152A865070ea9697bc8", parentTag)} navMenuSlug="marketing-primary-nav" className="navigation" {...props} />
  );
}

// id: "1c55af39-35b3-47c2-8755-a8f60540a3ed"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "9d78921b-a7d8-4842-bc68-ee210b654049"
export function HeaderTop1c55af3935b347c28755A8f60540a3ed(props: any) {
  return (
    <DefaultHeaderTopE5a46c72B5e048cc9024D8b314e5dc90 parentTag="HeaderTop1c55af3935b347c28755A8f60540a3ed" {...props} />
  );
}

// id: "52de4c72-35b3-4d4a-81d8-5d8ce9ded56b"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "6f1d5dbf-0941-45f1-89b4-b6fb76f47707"
export function WelcomeBack52de4c7235b34d4a81d85d8ce9ded56b(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack52de4c7235b34d4a81d85d8ce9ded56b" parentTag={buildClassName("WelcomeBack52de4c7235b34d4a81d85d8ce9ded56b", parentTag)} {...props} />
  );
}

// id: "30bfe7e5-dd78-4e8e-916d-6b3199deebc9"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "d9f56fcc-b2b2-4d63-9734-30eed59f0138"
export function Copyright30bfe7e5Dd784e8e916d6b3199deebc9(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright30bfe7e5Dd784e8e916d6b3199deebc9" parentTag={buildClassName("Copyright30bfe7e5Dd784e8e916d6b3199deebc9", parentTag)} {...props} />
  );
}

// id: "ddce869a-55f2-4673-9c67-492dc9597f28"
// title: ""
// type: :text
// key: "title"
// parent_id: "6f962ace-03a2-4a45-a856-bc8eb4e878d2"
export const TitleDdce869a55f246739c67492dc9597f28 = "About Us";

// id: "a174b1aa-9b6e-4e19-8487-ddaaf1492911"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "ce96a641-072a-46ef-b2f5-9e447638ac58"
export function HeroA174b1aa9b6e4e198487Ddaaf1492911(props: any) {
  return (
    <SecondaryMarketingHero3d08293e510d45ac8cb8309a621e6576 parentTag="HeroA174b1aa9b6e4e198487Ddaaf1492911" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "2a2f42e3-2218-4ec0-bea5-09d6578ef8ce"
// title: ""
// type: :text
// key: "class"
// parent_id: "97d41720-bbee-4152-a865-070ea9697bc8"
export const Class2a2f42e322184ec0Bea509d6578ef8ce = "navigation";

// id: "10f1f8e6-af74-4d25-8ef7-5fa567614377"
// title: ""
// type: :text
// key: "themeArea"
// parent_id: "cf5d3d7c-e646-4181-8a06-b3a6a2715f18"
export const ThemeArea10f1f8e6Af744d258ef75fa567614377 = "marketing";

// id: "76d3015a-3767-4ecd-b645-3d1b71641376"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "2883bd14-5fa0-4684-9e23-9ec4d007d92e"
export function Footer76d3015a37674ecdB6453d1b71641376(props: any) {
  return (
    <DefaultFooterD9f56fccB2b24d63973430eed59f0138 parentTag="Footer76d3015a37674ecdB6453d1b71641376" {...props} />
  );
}

// id: "3b58d531-e4b6-4123-a293-4d1fabdb496f"
// title: ""
// type: :text
// key: "url"
// parent_id: "2bc60502-021b-45d9-8ff8-293f70cdafb5"
export const Url3b58d531E4b64123A2934d1fabdb496f = "/";

// id: "b1b7042f-0374-497b-9615-214c5b6fa83e"
// title: ""
// type: :text
// key: "purpose"
// parent_id: "cf5d3d7c-e646-4181-8a06-b3a6a2715f18"
export const PurposeB1b7042f0374497b9615214c5b6fa83e = "footer";

// id: "81f4c293-7f94-431b-ba0b-e2839ad1b82a"
// title: ""
// type: :text
// key: "title"
// parent_id: "ce96a641-072a-46ef-b2f5-9e447638ac58"
export const Title81f4c2937f94431bBa0bE2839ad1b82a = "Secondary Marketing Title 1";

// id: "83730f58-f45a-4b30-b61d-6a0fd156d285"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "06d8f714-57f3-4d9a-b194-ab101caf98e4"
export const LogoType83730f58F45a4b30B61d6a0fd156d285 = "DEFAULT";

// id: "a8242b12-a6f1-4d6a-84ef-b1be001ddae4"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "53c9162b-eaa4-419a-928f-b326110cabf7"
export const PostSlugA8242b12A6f14d6a84efB1be001ddae4 = "home-page-cards";

// id: "9d78921b-a7d8-4842-bc68-ee210b654049"
// title: "Home Header Wrapper"
// type: :html
// key: "header-wrapper"
// parent_id: "6f1d5dbf-0941-45f1-89b4-b6fb76f47707"
export function HeaderWrapper9d78921bA7d84842Bc68Ee210b654049(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeaderWrapper9d78921bA7d84842Bc68Ee210b654049`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopE5a46c72B5e048cc9024D8b314e5dc90 parentTag="HeaderTop1c55af3935b347c28755A8f60540a3ed" {...props} />}
      </div>
      {props["hero-wrapper"] || <HeroWrapperFfbddc3aEba5414c810bD8213b83bac6 />}
    </div>
  );
}

// id: "d1d125fd-29bc-4e2e-be5a-fd6d63da3abf"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "fd86a3e3-87f1-4dd6-bc92-d001cfd91952"
export const LogoTypeD1d125fd29bc4e2eBe5aFd6d63da3abf = "FOOTER";

// id: "7f0ca3dd-efcd-409a-af9f-a3d94f4fc227"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "c6e4cd41-6b18-4ee5-b21e-ff1ca4f626ca"
export const LogoType7f0ca3ddEfcd409aAf9fA3d94f4fc227 = "DEFAULT";

const Components = {
  SecondaryMarketingHero3d08293e510d45ac8cb8309a621e6576,
  GroupflowBd4301e5169f4827876257145cee2bfb,
  HeroWrapperFfbddc3aEba5414c810bD8213b83bac6,
  PostSlugBe9bce04A6c84f2aB2ed270f93454f4f,
  PublicEventsPage2883bd145fa046849e239ec4d007d92e,
  Main9b2ace857e864120A98dBfcc4c323525,
  TitleC2b3b3da6f8d42ac80ad9e74dcca6aaf,
  ContentSlug85f8f53aB3194bc1B7c3E872bb344b72,
  SecondaryMarketingHeaderCe96a641072a46efB2f59e447638ac58,
  Header6f962ace03a24a45A856Bc8eb4e878d2,
  Title912ab4ccB4f44138Aa53F940756e8aa3,
  Hero5428d374213a423f9aaa1b0512cfc003,
  ApplicationPages7c8f73c503af4cbfB467A544f2b7af0e,
  Logo06d8f71457f34d9aB194Ab101caf98e4,
  Title9fb6c2d91dd04c26A907876089f80944,
  ButtonClassC5718482Ccf5499992e3C6e6d5973f06,
  DefaultFooterD9f56fccB2b24d63973430eed59f0138,
  HeaderA5eb75f925a442619d4d66edf35242c6,
  CardsE1b244cdEa9149afB8c28e116d501fce,
  PostSlug61c6b4a15188458a95cfAb280813007d,
  DefaultHeaderTopE5a46c72B5e048cc9024D8b314e5dc90,
  FooterE526be19Fde44d2f88f84fd0c51db5f4,
  Title717947d56eef4091A84d8b71f6f625f3,
  HomePage6f1d5dbf094145f189b4B6fb76f47707,
  MainF258fb1b23de4204B2f69f878e441d9c,
  ContentSlugE987c57e3c1c47869c8aAbb1627f0783,
  SecondaryPageD01dafa4435540249a9cC7e1b80d52af,
  FooterA9b7743b7aeb45c0Bc5186a97e1e2674,
  NavMenuSlug9e81614f91fd4c81A91bD48b3bbc06ab,
  JoinUsPage7bea41884bb34087A9df5fa26d578ba9,
  LinkedLogo2bc60502021b45d98ff8293f70cdafb5,
  Class226c45fcBe1a413b9f53D6995096d35d,
  AboutUsPage9acd145096904b2fAd7a7c2710eef3f7,
  LinksCf5d3d7cE64641818a06B3a6a2715f18,
  Cards53c9162bEaa4419a928fB326110cabf7,
  Title66f88ea9140f4c498e2cBab9841bae17,
  LabelC6e4cd416b184ee5B21eFf1ca4f626ca,
  Header5b29bdca0156419c8802662620207383,
  HeaderDf2aca67A9b84a82B494A93e21d7fdc4,
  Title0577bcf279cc4e12970bCe2bef024c5e,
  LogoFd86a3e387f14dd6Bc92D001cfd91952,
  Footer8170d60102e34d8e85b1791b87289cf6,
  NavMenuSlug0130ff7123b148a1838d457ad9cc1280,
  Header509c050c0de84f879d24409161a6419b,
  HeaderTopC554adefF85d4c7286617e66ea098ebf,
  ContentSlugA509dd76A0a94cf69304F80b146eaf74,
  Quote1bc6518f87284904905fA49b980efb0b,
  Navigation97d41720Bbee4152A865070ea9697bc8,
  HeaderTop1c55af3935b347c28755A8f60540a3ed,
  WelcomeBack52de4c7235b34d4a81d85d8ce9ded56b,
  Copyright30bfe7e5Dd784e8e916d6b3199deebc9,
  TitleDdce869a55f246739c67492dc9597f28,
  HeroA174b1aa9b6e4e198487Ddaaf1492911,
  Class2a2f42e322184ec0Bea509d6578ef8ce,
  ThemeArea10f1f8e6Af744d258ef75fa567614377,
  Footer76d3015a37674ecdB6453d1b71641376,
  Url3b58d531E4b64123A2934d1fabdb496f,
  PurposeB1b7042f0374497b9615214c5b6fa83e,
  Title81f4c2937f94431bBa0bE2839ad1b82a,
  LogoType83730f58F45a4b30B61d6a0fd156d285,
  PostSlugA8242b12A6f14d6a84efB1be001ddae4,
  HeaderWrapper9d78921bA7d84842Bc68Ee210b654049,
  LogoTypeD1d125fd29bc4e2eBe5aFd6d63da3abf,
  LogoType7f0ca3ddEfcd409aAf9fA3d94f4fc227
}

export default Components;